<template>
  <div id="app" class="app">
    <div class="toolbar" @click="isMenuActive = !isMenuActive">
      <div class="nav">
        <div class="nav__bar"></div>
        <div class="nav__bar"></div>
        <div class="nav__bar"></div>
      </div>
    </div>
    <div class="app__content" :class="{'app__content-active': isMenuActive}">
      <Home v-if="viewMode === 'home'" :best="best" :levels="levels"/>
      <Leaderboard v-if="viewMode === 'leaderboard'" :best="best"/>
      <Game v-if="viewMode === 'game'" :key="gameKey" :best="best"  :level="level" :levels="levels"/>

      <template v-if="viewMode !== 'game'">
        <div class="base-text text-center base-color mb-1">
          <a href="https://www.deeznutscoin.com/">www.deeznutscoin.com</a>
        </div>
        <a href="https://www.deeznutscoin.com/">
          <div class="base-text text-center button mb-1 mx-auto w-200">
            Buy Now
          </div>
        </a>
        <div class="base-text text-center mb-1 mx-auto w-200 social-links">
          <a class="social-links__link" target="_blank" href="https://www.instagram.com/deeznutscoin">
              <img src="./assets/social/insta.png"/>
          </a>
          <a class="social-links__link" target="_blank" href="https://twitter.com/DeezNuts">
              <img src="./assets/social/twitter.png"/>
          </a>
          <a class="social-links__link" target="_blank" href="https://t.me/Deeznutscoin">
              <img src="./assets/social/telegram.png"/>
          </a>
        </div>
      </template>
    </div>
    <div class="app__nav base-text" :class="{'app__nav-active': isMenuActive}">
        <div class="app__nav-container">
            <div class="app__nav-link">
              <div @click="openView('home')">Home</div>   
            </div>
            <div class="app__nav-link">
              <div @click="openView('game', 1)">Play Now</div>   
            </div>
            <div class="app__nav-link">
              <div @click="openView('leaderboard')" to="/leaderboard">Leaderboard</div>   
            </div>
        </div>
    </div>

  </div>
</template>
<script>
import Home from '@/views/Home';
import Game from '@/views/Game';
import Leaderboard from '@/views/Leaderboard';
import { mapGetters } from 'vuex'

export default {
  components: {
    Home,
    Leaderboard,
    Game
  },
  data() {
    return {
      viewMode: 'home',
      gameKey: 0,
      isMenuActive: false,
      levels: [
        {
          unlockedAt: 0
        },
        {
          unlockedAt: 25
        },
        {
          unlockedAt: 50
        }
      ],
      level: 1
    }
  },
  created() {
    this.$store.commit('getFrameRate');
    this.$store.commit('updateBest', localStorage.getItem('best') ? parseInt(localStorage.getItem('best')) : 0);
  },
  methods: {
    navigate(route) {
      this.isMenuActive = !this.isMenuActive;
      this.$router.push(route);
    },
    openView(view, level) {
      this.reloadGame();
      this.isMenuActive = false;
      this.viewMode = view;

      if (level) {
        this.level = 1;
      }
    },
    reloadGame() {
      this.gameKey += 1;
    }
  },
  computed: {
    ...mapGetters([
      'currentLevel',
      'currentFrameRate',
      'best'
    ])
  }
}
</script>

<style lang="scss">
$break-small: 700px;
body {
  background-color: #051428;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  a {
    color: unset;
    text-decoration: unset;
  }
}
.app {
  
  &__content {

    background-image: url(./assets/bg.png);

    @media screen and (max-width: $break-small) {
        background-image: url(./assets/bg-mobile.png);
    }

    width: 100%;
    height: 100%;
    position: fixed;
    background-repeat: repeat-x;
    background-size: cover;
    background-position: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: scroll;
    transition: all .5s ease-in-out;
  }
  &__content-active {
    left: -20%;
  }
  &__nav {
    width: 20%;
    height: 100%;
    position: fixed;
    left: 100%;
    top: 0;
    bottom: 0;
    transition: all .5s ease-in-out;
    background-color: #081426;
  }
  &__nav-active {
    left: 80%;
  }
  &__nav-container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: start;
    margin-top: 80px;
  }
  &__nav-link {
    width: 80%;
    margin: 0 auto 20px;
    font-size: 28px;
    cursor: pointer;
  }
  @media screen and (max-width: $break-small) {
    &__content-active {
      left: -60%;
    }
    &__nav {
      width: 60%;
    }
    &__nav-active {
      left: 40%;
    }
  }
}

.toolbar {
  width: 70px;
  height: 50px;
  position: fixed;
  cursor: pointer;
  z-index: 9;
  top: 0;
  right: 0;
  border-bottom-left-radius: 10px;
  background-color: rgba(206, 206, 206, 0.1);

  .nav {
    position: absolute;
    width: 30px;
    height: 20px;
    right: 18px;
    top: 15px;
    z-index: 9;

    &__bar {
      width: 100%;
      height: 3px;
      background-color: #fff;
      margin: 0 0 4px 0;
      border-bottom: 1px solid #081426;
      &:first-child {
        width: 50%;
      }
      &:last-child {
        width: 50%;
        right: 0;
        position: absolute;
      }
    }
  }
}
</style>
